import { render, staticRenderFns } from "./ResolveAction.vue?vue&type=template&id=f619a178&scoped=true&"
import script from "./ResolveAction.vue?vue&type=script&lang=js&"
export * from "./ResolveAction.vue?vue&type=script&lang=js&"
import style0 from "./ResolveAction.vue?vue&type=style&index=0&id=f619a178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f619a178",
  null
  
)

export default component.exports